import { combineReducers } from "redux";
import { tspayConstants } from "../actions/tspay/index.js";
import { banksConstants } from "../actions/tspay/banks";
import { consentsConstants } from "../actions/tspay/consents";
import { onboardingConstants } from "../actions/tspay/onboarding.js";

const defaultState = {
  accounts: {
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    },
    list: []
  },
  config: {
    data: null,
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    }
  },
  payment: {
    deadlines: null,
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    },
    isGettingIbanSuggestion: false
  },
  link: {
    result: null,
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    }
  },
  configStatus: {
    data: null,
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    }
  },
  isLoadingOnboardingSession: {
    isLoading: false,
    ended: false,
    error: false
  },
  isLoadingResendOnboardingMail: {
    isLoading: false,
    ended: false,
    error: true
  }
};

const defaultStateResources = {
  banks: [],
  products: [],
  isGettingBanks: false,
  isErrorBanks: false,
  isGettingProducts: false,
  isErrorProducts: false
};

const defaultStateConsents = {
  accounts: [],
  consentsList: {},
  consentsRecurring: {},
  isRequestingConsentList: false,
  isErrorRequestingConsentList: false,
  isGettingConsentAccounts: false,
  isErrorGettingConsentAccounts: false,
  isRequestingConsentRenew: false,
  isErrorRequestingConsentRenew: false,
  isRequestingConsentRecurring: false,
  isErrorRequestingConsentRecurring: false
};

function accounts(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState.accounts : state;
  switch (type) {
  case tspayConstants.LOAD_TSPAY_ACCOUNTS_START:
    return {
      ...defaultS,
      list: [],
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case tspayConstants.LOAD_TSPAY_ACCOUNTS_SUCCESS:
    return {
      ...defaultS,

      status: {
        started: false,
        error: false,
        ended: true
      },
      list: payload._embedded.accounts || []
    };
  case tspayConstants.LOAD_TSPAY_ACCOUNTS_ERROR:
    return {
      ...defaultS,
      list: [],
      status: {
        started: false,
        error: true,
        ended: true,
        errorInfo: {
          code: payload && payload.code ? payload.code : 500,
          message: payload && payload.message ? payload.message : "Errore"
        }
      }
    };
  default:
    return defaultS;
  }
}

function config(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState.config : state;
  switch (type) {
  case tspayConstants.LOAD_TSPAY_CONFIG_START:
    return {
      ...defaultS,

      data: null,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case tspayConstants.LOAD_TSPAY_CONFIG_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case tspayConstants.LOAD_TSPAY_CONFIG_ERROR:
    return {
      ...defaultS,

      data: null,
      status: {
        started: false,
        error: true,
        ended: true,
        errorInfo: {
          code: payload && payload.code ? payload.code : 500,
          message: payload && payload.message ? payload.message : "Errore"
        }
      }
    };
  default:
    return defaultS;
  }
}

function payment(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState.payment : state;
  switch (type) {
  case tspayConstants.REGISTER_TSPAY_PAYMENT_START:
    return {
      ...defaultS,
      result: payload,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case tspayConstants.REGISTER_TSPAY_PAYMENT_SUCCESS:
    return {
      ...defaultS,

      result: payload,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case tspayConstants.REGISTER_TSPAY_PAYMENT_ERROR:
    return {
      ...defaultS,

      result: payload,
      status: {
        started: false,
        error: true,
        ended: true
      }
    };
  case tspayConstants.SUGGEST_TSPAY_IBAN_START:
    return {
      ...defaultS,
      isGettingIbanSuggestion: true
    };
  case tspayConstants.SUGGEST_TSPAY_IBAN_SUCCESS:
  case tspayConstants.SUGGEST_TSPAY_IBAN_ERROR:
    return {
      ...defaultS,
      isGettingIbanSuggestion: false
    };
  default:
    return defaultS;
  }
}

function link(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState.link : state;
  switch (type) {
  case tspayConstants.LOAD_TSPAY_LINK_START:
    return {
      ...defaultS,
      result: payload,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case tspayConstants.LOAD_TSPAY_LINK_SUCCESS:
    return {
      ...defaultS,

      result: payload,
      status: {
        started: false,
        error: false,
        ended: true
      }
    };
  case tspayConstants.LOAD_TSPAY_LINK_ERROR:
    return {
      ...defaultS,

      result: null,
      status: {
        started: false,
        error: true,
        ended: false
      }
    };
  default:
    return defaultS;
  }
}

function resources(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultStateResources : state;
  switch (type) {
  case banksConstants.GET_TSPAY_BANKS_START:
    return { ...defaultS, banks: [], isGettingBanks: true };
  case banksConstants.GET_TSPAY_BANKS_SUCCESS:
    return { ...defaultS, banks: payload.providers, isGettingBanks: false };
  case banksConstants.GET_TSPAY_BANKS_ERROR:
    return { ...defaultS, isGettingBanks: false };
  case banksConstants.GET_TSPAY_PRODUCTS_START:
    return { ...defaultS, products: [], isGettingProducts: true };
  case banksConstants.GET_TSPAY_PRODUCTS_SUCCESS:
    return {
      ...defaultS,
      products: payload.providerProducts,
      isGettingProducts: false
    };
  case banksConstants.GET_TSPAY_PRODUCTS_ERROR:
    return { ...defaultS, isGettingProducts: false };
  default:
    return defaultS;
  }
}

function consents(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultStateConsents : state;
  switch (type) {
  case consentsConstants.CLEAR_CONSENT_ACCOUNT:
    return {
      ...defaultS,
      accounts: [],
      isGettingConsentAccounts: false
    };
  case consentsConstants.REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_START:
    return { ...defaultS, isRequestingConsentList: true };
  case consentsConstants.REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_SUCCESS:
    return {
      ...defaultS,
      consentsList: payload,
      isRequestingConsentList: false
    };
  case consentsConstants.REQUEST_TSPAY_CONSENTS_ACCOUNTS_LIST_ERROR:
    return { ...defaultS, isRequestingConsentList: false };
  case consentsConstants.GET_TSPAY_CONSENTS_ACCOUNTS_START:
    return { ...defaultS, isGettingConsentAccounts: true };
  case consentsConstants.GET_TSPAY_CONSENTS_ACCOUNTS_SUCCESS:
    return {
      ...defaultS,
      accounts: payload.accounts,
      isGettingConsentAccounts: false
    };
  case consentsConstants.GET_TSPAY_CONSENTS_ACCOUNTS_ERROR:
    return { ...defaultS, isGettingConsentAccounts: false };
  case tspayConstants.LOAD_RENEW_CONSENT_START:
    return {
      ...defaultS,
      isErrorRequestingConsentRenew: false,
      isRequestingConsentRenew: true
    };
  case tspayConstants.LOAD_RENEW_CONSENT_SUCCESS:
    return {
      ...defaultS,
      isErrorRequestingConsentRenew: false,
      isRequestingConsentRenew: false
    };
  case tspayConstants.LOAD_RENEW_CONSENT_ERROR:
    return {
      ...defaultS,
      isErrorRequestingConsentRenew: true,
      isRequestingConsentRenew: false
    };
  case consentsConstants.REQUEST_TSPAY_CONSENTS_RECURRING_START:
    return {
      ...defaultS,
      isErrorRequestingConsentRecurring: false,
      isRequestingConsentRecurring: true
    };
  case consentsConstants.REQUEST_TSPAY_CONSENTS_RECURRING_SUCCESS:
    return {
      ...defaultS,
      consentsRecurring: payload,
      isErrorRequestingConsentRecurring: false,
      isRequestingConsentRecurring: false
    };
  case consentsConstants.REQUEST_TSPAY_CONSENTS_RECURRING_ERROR:
    return {
      ...defaultS,
      isErrorRequestingConsentRecurring: true,
      isRequestingConsentRecurring: false
    };
  default:
    return defaultS;
  }
}

function configStatus(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState.configStatus : state;
  switch (type) {
  case onboardingConstants.GET_TSPAY_CONFIG_STATUS_START:
    return {
      ...defaultS,

      data: null,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case onboardingConstants.GET_TSPAY_CONFIG_STATUS_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        error: false,
        ended: true
      },
      data: payload
    };
  case onboardingConstants.GET_TSPAY_CONFIG_STATUS_ERROR:
    return {
      ...defaultS,

      data: null,
      status: {
        started: false,
        error: true,
        ended: true,
        errorInfo: {
          code: payload && payload.code ? payload.code : 500,
          message: payload && payload.message ? payload.message : "Errore"
        }
      }
    };
  default:
    return defaultS;
  }
}

function isLoadingOnboardingSession(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState.isLoadingOnboardingSession : state;
  switch (type) {
  case onboardingConstants.POST_TSPAY_ONBOARDING_SESSION_START:
    return {
      ...defaultS,
      isLoading: true,
      ended: false,
      error: false
    };
  case onboardingConstants.POST_TSPAY_ONBOARDING_SESSION_SUCCESS:
    return {
      ...defaultS,
      isLoading: false,
      ended: true,
      error: false
    };
  case onboardingConstants.POST_TSPAY_ONBOARDING_SESSION_ERROR:
    return {
      ...defaultS,
      isLoading: false,
      ended: true,
      error: true
    };
  default:
    return defaultS;
  }
}

function isLoadingResendOnboardingMail(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState.isLoadingResendOnboardingMail : state;
  switch (type) {
  case onboardingConstants.POST_RESEND_ONBOARDING_MAIL_START:
    return {
      ...defaultS,
      isLoading: true,
      ended: false,
      error: true
    };
  case onboardingConstants.POST_RESEND_ONBOARDING_MAIL_SUCCESS:
    return {
      ...defaultS,
      isLoading: false,
      ended: true,
      error: false
    };
  case onboardingConstants.POST_RESEND_ONBOARDING_MAIL_ERROR:
    return {
      ...defaultS,
      isLoading: false,
      ended: true,
      error: true
    };
  default:
    return defaultS;
  }
}

export default combineReducers({
  accounts: accounts,
  config: config,
  payment: payment,
  link: link,
  resources: resources,
  consents: consents,
  configStatus: configStatus,
  isLoadingOnboardingSession: isLoadingOnboardingSession,
  isLoadingResendOnboardingMail: isLoadingResendOnboardingMail
});
